<template>
  <footer class="footer">
    <div class="footer__wrapper">
      <a
        class="footer__logo"
        href="https://www.choice.com.au"
      >
        Choice
      </a>
      <p>
        You deserve better, safer and fairer products and services.<br>
        We're the people working to make that happen.
      </p>
      <ul class="footer__links">
        <li>
          <a
            href="https://www.choice.com.au/policies-terms-and-conditions/privacy-policy"
          >Privacy policy</a>
        </li>
        <li>
          <a
            href="https://www.choice.com.au/policies-terms-and-conditions/terms-and-conditions"
          >Terms & Conditions</a>
        </li>
        <li>&copy; CHOICE {{ new Date().getFullYear() }}</li>
      </ul>
    </div>
  </footer>
</template>
<script setup>
</script>
<style scoped lang="scss">
.footer {
  background: $colour_choice_secondary;
  padding: 40px 0;
  text-align: center;

  @include med-breakpoint() {
    display: flex;
    align-items: center;
    padding: 0;
    min-height: 240px;
  }

  &__wrapper {
    max-width: 640px;
    margin: 0 auto;
    font-weight: bold;
    color: $colour_white;
    padding: 0 1rem;
  }

  p {
    line-height: 24px;
  }

  a {
    color: $colour_white;
    font-weight: bold;
    text-decoration: none;
    &:hover {
      text-decoration: underline;

      @include ctm-max-breakpoint(480px) {
        text-decoration: none;
      }
    }
  }

  &__logo {
    display: block;
    background-image: url($VUE_APP_IMAGE_BASE_URL + '/images/logo_choice.svg');
    background-color: transparent;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    width: 118px;
    height: 34px;
    text-indent: -5000px;
    margin: 0 auto pxtorem(24px);
  }

  &__links {
    padding: 0;
    margin: 0;

    li {
      padding: 0 16px;
      display: inline-block;
      font-size: 14px;
      line-height: 18px;
      border-left: 1px solid #fff;

      @include ctm-max-breakpoint(480px) {
        padding-right: 0;
      }

      &:first-child {
        border: 0;
        padding-left: 0;
        padding-right: 16px;
      }

      &:last-child {
        @include ctm-max-breakpoint(480px) {
          display: block;
          border: 0;
          margin: 0.5rem 0 0;
        }
      }
    }
  }
}
</style>
